<template>
  <section>
    <form @submit.prevent="submit">
      <field
        label="Company name"
        @input="$v.resource.name.$touch()"
        v-model="resource.name"
        :error="nameError"/>

      <field
        label="Company Email"
        helpText="This will be used for the sites contact form submissions"
        @input="$v.resource.email.$touch()"
        v-model="resource.email"
        :error="emailError"/>

      <field
        label="Owner"
        type="select"
        v-if="isAdmin"
        @input="$v.resource.owner_id.$touch()"
        v-model="resource.owner_id"
        :error="owner_idError"
        :options="users"/>

      <field
        v-if="isAdmin"
        label="White label"
        type="checkbox"
        @input="$v.resource.white_label.$touch()"
        v-model="resource.white_label"
        :error="white_labelError"/>

      <div class="btn-save">
        <Btn primary>Save Changes</Btn>
      </div>
    </form>

    <p class="small">If you'd like to transfer ownership of this company, please contact our team.</p>
  </section>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {mapState} from 'vuex'

import {errorMessages} from '@/lib/error_messages'
import {required, email} from 'vuelidate/lib/validators'

export default {
  name: 'CompanyForm',

  mixins: [form],

  props: {
    users: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...errorMessages(['name', 'email', 'owner_id', 'white_label']),
    ...mapState(['currentUser']),

    isAdmin() {
      return this.currentUser.admin
    }
  },

  components: {
    Btn
  },

  validations: {
    resource: {
      name: {required},
      email: {required, email},
      owner_id: {required},
      white_label: {}
    }
  }
}
</script>
